export enum GooglePlacesAutocompleteType {
  address = 'address',
  postalCode = '(regions)',
}
